<div class="cli-auth">
  <div class="cli-auth__card">
    <ng-container [ngSwitch]="state">
      <div *ngSwitchCase="'loading'" class="cli-auth__body">
        <p>Checking that code…</p>
      </div>

      <div *ngSwitchCase="'confirm'" class="cli-auth__body">
        <h1>Approve command-line access?</h1>
        <p class="cli-auth__lead">
          A command-line tool is asking to sign in as
          <strong>{{ operatorEmail }}</strong
          >. It will receive a token with your full admin access.
        </p>

        <p class="cli-auth__instruction">
          Only approve if this code matches the one your terminal printed:
        </p>
        <p class="cli-auth__code">{{ request?.userCode }}</p>

        <dl class="cli-auth__meta" *ngIf="request?.clientLabel || request?.requestedFrom">
          <ng-container *ngIf="request?.clientLabel">
            <dt>Tool</dt>
            <dd>{{ request?.clientLabel }}</dd>
          </ng-container>
          <ng-container *ngIf="request?.requestedFrom">
            <dt>Requested from</dt>
            <dd>{{ request?.requestedFrom }}</dd>
          </ng-container>
        </dl>

        <p class="cli-auth__warning">
          If you did not start this yourself, deny it. Approving hands your
          admin access to whoever did.
        </p>

        <div class="cli-auth__actions">
          <button
            type="button"
            class="cli-auth__button cli-auth__button--approve"
            [disabled]="submitting"
            (click)="approve()"
          >
            Approve
          </button>
          <button
            type="button"
            class="cli-auth__button cli-auth__button--deny"
            [disabled]="submitting"
            (click)="deny()"
          >
            Deny
          </button>
        </div>
      </div>

      <div *ngSwitchCase="'approved'" class="cli-auth__body">
        <h1>Approved</h1>
        <p>Your terminal has the token. You can close this tab.</p>
      </div>

      <div *ngSwitchCase="'denied'" class="cli-auth__body">
        <h1>Denied</h1>
        <p>No token was issued. You can close this tab.</p>
      </div>

      <div *ngSwitchCase="'error'" class="cli-auth__body">
        <h1>Something is off</h1>
        <p>{{ errorMessage }}</p>
      </div>
    </ng-container>
  </div>
</div>
